module.exports = __webpack_public_path__ + "static/media/effect-into-lesson.9744fab5.png";